import 'bootstrap/scss/bootstrap.scss'
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import 'bootstrap.native';
import './controllers/default';
import './controllers/homepage';
import { WPPages } from "../domain/modules/wp-pages";

export default (async () => {
  window.addEventListener('load', async () => { 
    import('./controllers/navigation');
    import('./controllers/all');
    if(WPPages.hasWebsiteStagesComponent()){
      await import('./controllers/website-stages'); 
    } 

    if(WPPages.hasTestimonialSlider()){
      await import('./controllers/testimonial-slider'); 
    } 

    if(WPPages.hasTestimonialSlider2()){
      await import('./controllers/two-testimonials'); 
    } 

    if(WPPages.hasTestimonialFooterSlider()){
      await import('./controllers/footer-testimonial-slider'); 
    } 
    
    if(WPPages.hasMonitorSlider()){
      await import('./controllers/monitor-slider'); 
    } 

    if(WPPages.isOnAboutPage()){
      await import('./controllers/about'); 
    } 

    if(WPPages.hasCardSlider()){
      await import('./controllers/card-slider'); 
    } 
  })
  
  
})();